import { gql, useQuery } from '@apollo/client';
import { Camera } from 'types/Camera';
import { Account } from 'types/Account';

const CAMERAS_DATA = gql`
  query GetCamerasList(
    $isCloud: Boolean!
    $masterCompanyId: Int!
    $accountId: Int!
    $accountType: Int!
    $email: String
    $doorId: Int
    $isSIMCloud: Boolean
    $userName: String
  ) {
    getCamerasList(
      isCloud: $isCloud
      masterCompanyId: $masterCompanyId
      accountId: $accountId
      accountType: $accountType
      email: $email
      doorId: $doorId
      isSIMCloud: $isSIMCloud
      userName: $userName
    ) {
      name
      snapUrl
      token
    }
  }
`;

function useGetCamerasListApi({ accountSelected }: { accountSelected: Account }) {
  const { data, ...queryReturns } = useQuery<{ getCamerasList: Camera[] }>(CAMERAS_DATA, {
    variables: { ...accountSelected, accountId: accountSelected.id },
    notifyOnNetworkStatusChange: true,
  });
  const cameras = data?.getCamerasList;

  return {
    cameras,
    ...queryReturns,
  };
}

export default useGetCamerasListApi;
